import isBrowser from 'is-browser';
import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  defaultDataIdFromObject,
} from '@apollo/client';

export function createApolloClient(
  graphQLServerUrl: string
): ApolloClient<any> {
  const httpLink = createHttpLink({
    uri: graphQLServerUrl,
    fetch: fetch,
    headers: {
      'apollographql-client-name': 'VW_US_QUICK-START-GUIDE_FA',
    },
  });

  const typePolicies = {
    Query: {
      fields: {
        getModelYears: { merge: false },
        getModelsByYear: { merge: false },
        getQSGByYearAndModel: { merge: false },
        getAllModels: { merge: false },
      },
    },
  };

  const cache = new InMemoryCache({
    typePolicies,
    dataIdFromObject(responseObject) {
      switch (responseObject.__typename) {
        default:
          return defaultDataIdFromObject(responseObject);
      }
    },
  });

  return new ApolloClient({
    link: httpLink,
    cache: cache,
    ssrMode: !isBrowser,
  });
}
